<template>
  <div class="cs-artisticalLabel-container">
    <div class="cs-artisticalLabel-background">
      {{ backgroundText }}
    </div>
    <span class="cs-artisticalLabel-text">{{ labelText }}</span>
  </div>
</template>

<style lang="scss" scoped>
.cs-artisticalLabel-container {
  position: relative;
  display: inline-block;
  min-width: 140px;

  .cs-artisticalLabel-background {
    position: absolute;
    top: -16px;
    left: 0;
    //bottom: 0;
    //right: 0;
    //z-index: -1;
    overflow: hidden;
    //color: #c6afaf;
    color: grey;
    font-size: 50px;
    width: 100%;
    opacity: 0.3;
    text-shadow: 1px 1px 1px grey;
  }

  .cs-artisticalLabel-text {
    font-size: 28px;
    font-weight: bold;
  }
}
</style>

<script>
export default {
  props: {
    backgroundText: String,
    labelText: String,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/common/artisticalLabel.vue